/* global IS_PRODUCTION */
import { toNumber } from 'lodash-es'

const validateHeadingLevel = level => {
  const parsedLevel = toNumber(level)
  return parsedLevel > 0 && parsedLevel < 7
}

export default {
  name: 'BaseHeading',
  render(createElement) {
    return createElement(
      `h${this.headingLevel}`,
      {
        ...(!this.noLayout && {
          class: `h${this.headingLayout} text-${this.alignment}`,
          ...this.$attrs,
        }),
      },
      this.$slots.default,
    )
  },
  props: {
    level: {
      type: [String, Number],
      required: true,
      validator(value) {
        const isValid = validateHeadingLevel(value)

        if (!IS_PRODUCTION && !isValid) {
          console.group('ERROR::BaseHeading')
          console.error('BaseHeading: validator -> level')
          console.table({ level: value })
          console.groupEnd()
        }

        return isValid
      },
    },
    layout: {
      type: [String, Number],
    },
    noLayout: {
      type: Boolean,
      default: false,
    },
    alignment: {
      type: String,
      default: 'left',
    },
  },
  data() {
    return {
      defaultHeadingLevel: 2,
    }
  },
  computed: {
    isValidHeadingLevel() {
      return validateHeadingLevel(this.level)
    },
    headingLevel() {
      if (this.isValidHeadingLevel) {
        return this.level
      }

      return this.defaultHeadingLevel
    },
    headingLayout() {
      return this.layout ? this.layout : this.headingLevel
    },
  },
}
